import moment from 'moment/moment';
const axios = require('axios');

(() => {
  const calendarTable = '.barbecue-calendar-table';
  const prevWeekButton = '.move-to-prev-week';
  const nextWeekButton = '.move-to-next-week';
  const calendarInfo = '.barbecue-calendar-info';
  const adultNumPulldown = '.barbecue-adult-num'
  const kidsNumPulldown = '.barbecue-kids-num';
  const babyNumPulldown = '.barbecue-baby-num';
  const reserveDateSelect = '#barbecue-reserve-date-select';
  const grassAm = '.grass-am';
  const grassPm = '.grass-pm';
  const loofAm = '.loof-am';
  const loofPm = '.loof-pm';
  const barbecuePlanNextButton = '.barbecue-plan-next-button';
  const editBarbecueReserveDateSelect = '.edit-barbecue-reserve-date-select';
  var firstDateValue = {};
  var lastDateValue = {};
  var firstDateWeakMap = new WeakMap;
  var lastDateWeakMap = new WeakMap;
  const futureDate = moment().add(6, 'months').toDate();
  //開園日である10月31日まで下記使用
  const openDateObj = new Date('2020/10/31');
  const DATE_FORMAT = 'YYYY年MM月DD日（dd）';
  const showDisabledBtn = '.show-disabled-button';
  const showActiveBtn = '.show-active-button';

  const init = () => {
    if (location.href.indexOf('customer/barbecue/barbecue_reservation') < 1 ) {
      return
    }
    if ($('.step-1').length < 1) {
      return
    }
    $(calendarTable).hide();
    $(prevWeekButton).hide();
    $(nextWeekButton).hide();
    $(calendarInfo).hide();

    $(barbecuePlanNextButton).prop('disabled', true);
    $(showDisabledBtn).show();
    $(showActiveBtn).hide();
    $('.after_info_open_calendar').removeClass('active');
    $('body')
      .on('change', adultNumPulldown, showInitWeekReservationStatus)
      .on('change', kidsNumPulldown, showInitWeekReservationStatus)
      .on('change', babyNumPulldown, showInitWeekReservationStatus)
      .on('change', editBarbecueReserveDateSelect, showInitWeekReservationStatus)
      .on('change', reserveDateSelect, showInitWeekReservationStatus)
      .on('click', nextWeekButton, showNextWeekReservationStatus)
      .on('click', prevWeekButton, showPrevWeekReservationStatus)
      .on('click', grassAm, setGrassAmValue)
      .on('click', grassPm, setGrassPmValue)
      .on('click', loofAm, setLoofAmValue)
      .on('click', loofPm, setLoofPmValue);
    showInitWeekReservationStatus();

    $(reserveDateSelect).on('apply.daterangepicker', (ev, picker) => {
      $(reserveDateSelect).val(picker.startDate.format(DATE_FORMAT))
    })
  }

  const setGrassAmValue = e => {
    e.preventDefault();
    $(calendarTable).find('td').css('background-color', '').removeClass('select-date')
    $(calendarTable).find('td').removeClass('reservation-check-mark');
    const $element = $(e.currentTarget);
    $element.parent().addClass('reservation-check-mark');
    $element.parent().addClass('select-date');
    var date = $element.data('date');
    document.getElementById('barbecue-reserve-date').value = date;
    document.getElementById('barbecue-am-or-pm').value = 'am';
    document.getElementById('barbecue-area-id').value = 1;
    $(barbecuePlanNextButton).prop('disabled', false);
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
    document.getElementById('barbecue-reserve-date-select').value = moment(date).format(DATE_FORMAT);
  }

  const setGrassPmValue = e => {
    e.preventDefault();
    $(calendarTable).find('td').css('background-color', '').removeClass('select-date')
    $(calendarTable).find('td').removeClass('reservation-check-mark');
    const $element = $(e.currentTarget);
    $element.parent().addClass('reservation-check-mark');
    $element.parent().addClass('select-date');
    var date = $element.data('date');
    document.getElementById('barbecue-reserve-date').value = date;
    document.getElementById('barbecue-am-or-pm').value = 'pm';
    document.getElementById('barbecue-area-id').value = 1;
    $(barbecuePlanNextButton).prop('disabled', false);
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
    document.getElementById('barbecue-reserve-date-select').value = moment(date).format(DATE_FORMAT);
  }

  const setLoofAmValue = e => {
    e.preventDefault();
    $(calendarTable).find('td').css('background-color', '').removeClass('select-date')
    $(calendarTable).find('td').removeClass('reservation-check-mark');
    const $element = $(e.currentTarget);
    $element.parent().addClass('reservation-check-mark');
    $element.parent().addClass('select-date');
    var date = $element.data('date');
    document.getElementById('barbecue-reserve-date').value = date;
    document.getElementById('barbecue-am-or-pm').value = 'am';
    document.getElementById('barbecue-area-id').value = 2;
    $(barbecuePlanNextButton).prop('disabled', false);
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
    document.getElementById('barbecue-reserve-date-select').value = moment(date).format(DATE_FORMAT);
  }

  const setLoofPmValue = e => {
    e.preventDefault();
    $(calendarTable).find('td').css('background-color', '').removeClass('select-date')
    $(calendarTable).find('td').removeClass('reservation-check-mark');
    const $element = $(e.currentTarget);
    $element.parent().addClass('reservation-check-mark');
    $element.parent().addClass('select-date');
    var date = $element.data('date');
    document.getElementById('barbecue-reserve-date').value = date;
    document.getElementById('barbecue-am-or-pm').value = 'pm';
    document.getElementById('barbecue-area-id').value = 2;
    $(barbecuePlanNextButton).prop('disabled', false);
    $(showDisabledBtn).hide();
    $(showActiveBtn).show();
    document.getElementById('barbecue-reserve-date-select').value = moment(date).format(DATE_FORMAT);
  }

  const showInitWeekReservationStatus = (e) => {
    if (e) {
      e.preventDefault();
    }
    if ($(adultNumPulldown).val() < 1) {
      $(calendarTable).hide();
      $(prevWeekButton).hide();
      $(nextWeekButton).hide();
      $(calendarInfo).hide();
      $(barbecuePlanNextButton).prop('disabled', true);
      $(showDisabledBtn).show();
      $(showActiveBtn).hide();
      return false
    }
    let reserveDateSelectString = $(reserveDateSelect).val();
    reserveDateSelectString = reserveDateSelectString.replace(/\(|\)|（|）|日|月|火|水|木|金|土|年|月|日/g, '');
    const reserveDateSelectObj = moment(reserveDateSelectString).toDate();
    let currentDateObj = new Date();
    currentDateObj.setDate(currentDateObj.getDate() + 2);
    if (currentDateObj.getTime() < openDateObj.getTime())  {
      currentDateObj = openDateObj;
    }

    if (reserveDateSelectObj.getTime() > currentDateObj.getTime()) {
      var nextDateString = reserveDateSelectString;
    } else {
      var nextDateString = getStringFromDate(currentDateObj);
    }

    $(calendarTable).show();
    if (reserveDateSelectObj.getTime() == currentDateObj.getTime()) {
      $(prevWeekButton).addClass('disabled');
    } else {
      $(prevWeekButton).removeClass('disabled').prop('disabled', false);
    }
    if (reserveDateSelectObj.getTime() < currentDateObj.getTime()) {
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
    }
    $(prevWeekButton).show();
    $(nextWeekButton).show();
    $('.before_info_open_calendar').hide();
    $('.after_info_open_calendar').addClass('active');
    removePrependedCalendarInfo();
    fetchReservationStatus(nextDateString);
    $(calendarInfo).show();

    const selectedDate = $('#barbecue-reserve-date').val();
    const selectedAmPm = $('#barbecue-am-or-pm').val();
    const selectedArea = $('#barbecue-area-id').val();

    if (selectedDate && selectedAmPm && selectedArea) {
      $(barbecuePlanNextButton).prop('disabled', false);
      $(showDisabledBtn).hide();
      $(showActiveBtn).show();
    }
    false
  }

  const showNextWeekReservationStatus = e => {
    e.preventDefault();
    $(prevWeekButton).prop('disabled', false).removeClass('disabled');
    const lastDateString = lastDateWeakMap.get(lastDateValue);
    var lastDate = new Date(lastDateString);
    lastDate.setDate(lastDate.getDate() + 1);
    const nextDateString = getStringFromDate(lastDate);
    removePrependedCalendarInfo();
    fetchReservationStatus(nextDateString);
  }

  const showPrevWeekReservationStatus = e => {
    e.preventDefault();
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 2);
    if (currentDate.getTime() < openDateObj.getTime())  {
      currentDate = openDateObj;
    }

    const firstDateString = firstDateWeakMap.get(firstDateValue);
    var firstDate = new Date(firstDateString);
    firstDate.setDate(firstDate.getDate() - 5);
    if (currentDate.getTime() > firstDate.getTime()) {
      firstDate = currentDate;
    }
    if (moment(firstDate).format('YYYY/MM/DD') == moment(currentDate).format('YYYY/MM/DD')) {
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
      $(showDisabledBtn).show();
      $(showActiveBtn).hide();
    }

    const prevWeekfirstDateString = getStringFromDate(firstDate);
    removePrependedCalendarInfo();
    fetchReservationStatus(prevWeekfirstDateString);
  }

  const fetchReservationStatus = date => {
    return axios.get(process.env.JS_BASE_URL + 'api/v1/barbecue_calendars', {
      params: {
        date: date
      }
    })
    .then(response => {
      removePrependedCalendarInfo();
      const grassAreaAmReservations = response.data[0];
      const grassAreaPmReservations = response.data[1];
      const loofAreaAmReservations = response.data[2];
      const loofAreaPmReservations = response.data[3];

      $('#calendar-month').prepend('<td colspan="2"></td>');
      $('#calendar-date').prepend('<th class="time">時間</th>');
      $('#calendar-date').prepend('<th class="area">エリア</th>');
      if (grassAreaAmReservations) {
        grassAreaAmReservations.forEach(reservation => {
          let selectedDate = $('#barbecue-reserve-date').val();
          const selectedAmPm = $('#barbecue-am-or-pm').val();
          const selectedArea = $('#barbecue-area-id').val();
          if (selectedAmPm != 'am' || selectedArea != 1) {
            selectedDate = ''
          }

          const date = new Date(reservation.date);
          const reservationDate = date.getDate();
          const reservationMonth = date.getMonth() + 1;
          const jaWDay = getJapaneseWDay(date);
          const wDay = date.getDay();

          let addTdStyle = '';
          let addAStyle = '';
          let addSelectClass = '';
          if (selectedDate && moment(reservation.date).format('YYYYMMDD') == moment(selectedDate).format('YYYYMMDD')) {
            addTdStyle = 'background-color: #527342;';
            addAStyle = 'background-color: #fff;';
            addSelectClass = 'select-date reservation-check-mark';
          }

          $('#calendar-month').append(`<td>${reservationMonth}月</td>`);
          if (wDay === 0) {
            $('#calendar-date').append(`<td class='barbecue-calender-date sunday-reservation'>${jaWDay}<br><span class="date">${reservationDate}</span></td>`);
          } else if (wDay === 6) {
            $('#calendar-date').append(`<td class='barbecue-calender-date saturday-reservation'>${jaWDay}<br><span class="date">${reservationDate}</span></td>`);
          } else {
            $('#calendar-date').append(`<td class='barbecue-calender-date'>${jaWDay}<br><span class="date">${reservationDate}</span></td>`);
          }

          if (futureDate.getTime() > date.getTime()) {
            if (reservation.non_business_date === true) {
              $('#calendar-grass-am-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
            } else {
              if (reservation.reservation_rate >= 100) {
                $('#calendar-grass-am-reservation-num').append(`<td class='unavailable-reservation times-mark'></td>`);
              } else if (reservation.reservation_rate >= 80) {
                $('#calendar-grass-am-reservation-num').append(`<td class="${addSelectClass}" style="${addTdStyle}"><a class='grass-am click-underline triangle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              } else {
                $('#calendar-grass-am-reservation-num').append(`<td class="${addSelectClass}" style="${addTdStyle}"><a class='grass-am click-underline circle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              }
            }
          }
        })
        var firstDate = grassAreaAmReservations[0].date;
        var lastDate = grassAreaAmReservations[4].date;
        $('#calendar-grass-am-reservation-num').prepend('<td>午前</td>');
        $('#calendar-grass-am-reservation-num').prepend(`<td rowspan="2"><a href='' class='text-link barbecue-grass-modal-button' data-target='#barbecueAreaModal' data-toggle='modal'>${grassAreaAmReservations[0].area_name}</a></td>`);
      }

      if (grassAreaPmReservations) {
        grassAreaPmReservations.forEach(reservation => {
          let selectedDate = $('#barbecue-reserve-date').val();
          const selectedAmPm = $('#barbecue-am-or-pm').val();
          const selectedArea = $('#barbecue-area-id').val();
          if (selectedAmPm != 'pm' || selectedArea != 1) {
            selectedDate = ''
          }
          let addTdStyle = '';
          let addAStyle = '';
          let addSelectClass = '';
          if (selectedDate && moment(reservation.date).format('YYYYMMDD') == moment(selectedDate).format('YYYYMMDD')) {
            addTdStyle = 'background-color: #527342;';
            addAStyle = 'background-color: #fff;';
            addSelectClass = 'select-date reservation-check-mark';
          }

          const date = new Date(reservation.date);

          if (futureDate.getTime() > date.getTime()) {
            if (reservation.non_business_date === true) {
              $('#calendar-grass-pm-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
            } else {
              if (reservation.reservation_rate >= 100) {
                $('#calendar-grass-pm-reservation-num').append(`<td class='unavailable-reservation times-mark'></td>`);
              } else if (reservation.reservation_rate >= 80) {
                $('#calendar-grass-pm-reservation-num').append(`<td style="${addTdStyle}" class="${addSelectClass}"><a class='grass-pm click-underline triangle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              } else {
                $('#calendar-grass-pm-reservation-num').append(`<td style="${addTdStyle}" class="${addSelectClass}"><a class='grass-pm click-underline circle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              }
            }
          } else {
            $('#calendar-grass-pm-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
          }
        })
        $('#calendar-grass-pm-reservation-num').prepend('<td class="barbecue-reservation-pm">午後</td>');
      }
      // $('#calendar-grass-pm-reservation-num').prepend(`<td>${grassAreaPmReservations[0].area_name}</td>`);
      if (loofAreaAmReservations) {
        loofAreaAmReservations.forEach(reservation => {
          const date = new Date(reservation.date);

          let selectedDate = $('#barbecue-reserve-date').val();
          const selectedAmPm = $('#barbecue-am-or-pm').val();
          const selectedArea = $('#barbecue-area-id').val();
          if (selectedAmPm != 'am' || selectedArea != 2) {
            selectedDate = ''
          }
          let addTdStyle = '';
          let addAStyle = '';
          let addSelectClass = '';
          if (selectedDate && moment(reservation.date).format('YYYYMMDD') == moment(selectedDate).format('YYYYMMDD')) {
            addTdStyle = 'background-color: #527342;';
            addAStyle = 'background-color: #fff;';
            addSelectClass = 'select-date reservation-check-mark';
          }

          if (futureDate.getTime() > date.getTime()) {
            if (reservation.non_business_date === true) {
              $('#calendar-loof-am-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
            } else {
              if (reservation.reservation_rate >= 100) {
                $('#calendar-loof-am-reservation-num').append(`<td class='unavailable-reservation times-mark'></td>`);
              } else if (reservation.reservation_rate >= 80) {
                $('#calendar-loof-am-reservation-num').append(`<td style="${addTdStyle}" class="${addSelectClass}"><a class='loof-am click-underline triangle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              } else {
                $('#calendar-loof-am-reservation-num').append(`<td style="${addTdStyle}" class="${addSelectClass}"><a class='loof-am click-underline circle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              }
            }
          } else {
            $('#calendar-loof-am-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
          }
        })
        $('#calendar-loof-am-reservation-num').prepend('<td>午前</td>');
        $('#calendar-loof-am-reservation-num').prepend(`<td rowspan="2"><a href='' class='text-link barbecue-loof-modal-button' data-target='#barbecueAreaModal' data-toggle='modal'>${loofAreaAmReservations[0].area_name}</a></td>`);
      }

      if (loofAreaPmReservations) {
        loofAreaPmReservations.forEach(reservation => {
          const date = new Date(reservation.date);

          let selectedDate = $('#barbecue-reserve-date').val();
          const selectedAmPm = $('#barbecue-am-or-pm').val();
          const selectedArea = $('#barbecue-area-id').val();
          if (selectedAmPm != 'pm' || selectedArea != 2) {
            selectedDate = ''
          }
          let addTdStyle = '';
          let addAStyle = '';
          let addSelectClass = '';
          if (selectedDate && moment(reservation.date).format('YYYYMMDD') == moment(selectedDate).format('YYYYMMDD')) {
            addTdStyle = 'background-color: #527342;';
            addAStyle = 'background-color: #fff;';
            addSelectClass = 'select-date reservation-check-mark';
          }


          if (futureDate.getTime() > date.getTime()) {
            if (reservation.non_business_date === true) {
              $('#calendar-loof-pm-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
            } else {
              if (reservation.reservation_rate >= 100) {
                $('#calendar-loof-pm-reservation-num').append(`<td class='unavailable-reservation times-mark'></td>`);
              } else if (reservation.reservation_rate >= 80) {
                $('#calendar-loof-pm-reservation-num').append(`<td style="${addTdStyle}" class="${addSelectClass}"><a class='loof-pm click-underline triangle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              } else {
                $('#calendar-loof-pm-reservation-num').append(`<td style="${addTdStyle}" class="${addSelectClass}"><a class='loof-pm click-underline circle-mark' data-date=${reservation.date} href='' style="${addAStyle}"></a></td>`);
              }
            }
          } else {
            $('#calendar-loof-pm-reservation-num').append(`<td class='unavailable-reservation'>-</td>`);
          }
        })
        $('#calendar-loof-pm-reservation-num').prepend('<td>午後</td>');
      }
      // $('#calendar-loof-pm-reservation-num').prepend(`<td>${loofAreaPmReservations[0].area_name}</td>`);

      firstDateWeakMap.set(firstDateValue, firstDate);
      lastDateWeakMap.set(lastDateValue, lastDate);
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const removePrependedCalendarInfo = () => {
    $('#calendar-month').empty();
    $('#calendar-date').empty();
    $('#calendar-grass-am-reservation-num').empty();
    $('#calendar-grass-pm-reservation-num').empty();
    $('#calendar-loof-am-reservation-num').empty();
    $('#calendar-loof-pm-reservation-num').empty();
  }

  const getStringFromDate = lastDate => {
    const year_str = lastDate.getFullYear();
    var month_str = 1 + lastDate.getMonth();
    var day_str = lastDate.getDate();
    month_str = ('0' + month_str).slice(-2);
    day_str = ('0' + day_str).slice(-2);
    let nextDateString = 'YYYY-MM-DD'
    nextDateString = nextDateString.replace(/YYYY/g, year_str);
    nextDateString = nextDateString.replace(/MM/g, month_str);
    nextDateString = nextDateString.replace(/DD/g, day_str);
    return nextDateString;
  }

  const getJapaneseWDay = date => {
    var weekChars = ['日', '月', '火', '水', '木', '金', '土'];
    let wDay = date.getDay();
    return weekChars[wDay];
  }
  $(init);
})();

